import React from "react";
import styled from "styled-components";
// import { FaFacebook } from "react-icons/fa";

const SocialLinkStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: ${(props) => (props.type === "medium" ? "50px" : "100px")};
  height: ${(props) => (props.type === "medium" ? "50px" : "100px")};
  padding: 0;
  margin: 20px;
  background: var(--background-color-main);
  border-radius: ${(props) => (props.type === "medium" ? "50px" : "15px")};
  box-shadow: -2px -2px 3px rgba(255, 255, 255, 0.05),
    3px 3px 3px rgba(0, 0, 0, 0.2);
`;
const Link = styled.a`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 100%;
  text-align: center;
  text-decoration: none;

  img {
    color: #555;
    height: ${(props) => (props.type === "medium" ? "16px" : "50px")};
    width: ${(props) => (props.type === "medium" ? "16px" : "50px")};
    border-radius: ${(props) => (props.rounded ? "50%" : "15px")};

    &:hover {
      color: #00f3ff;
      text-shadow: 0 0 15px #00f3ff;
    }
  }

  p {
    font-size: 10px;
    letter-spacing: 2px;
    font-size: bold;
  }
`;

function SocialLink({ imgSrc, link, medium, title, rounded }) {
  return (
    <SocialLinkStyled type={medium}>
      <Link href={link} target="_blank" rounded={rounded}>
        <img src={imgSrc} alt={title} />
        <p>{title}</p>
      </Link>
    </SocialLinkStyled>
  );
}

export default SocialLink;
